<template>
  <div class="page-content">
    <div class="headings">
      <h3>{{ $t("lang.dashboard.printer_production") }}</h3>
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <br><br/>
        <v-row>
          <v-col><v-text-field :label="$t('lang.admin.device_form.label_select_warehouse')" outlined v-model="warehouse"></v-text-field></v-col>
          <v-col><v-text-field :label="$t('lang.admin.device_form.label_select_document_number')" outlined v-model="document_number"></v-text-field></v-col>
          <div class="select-box col-md-6"><v-select :items="states" v-model="filter_state" prefix="Filter state:   " outlined></v-select></div>

          <v-col class="d-flex justify-content-center" md="auto">
            <v-btn color="#FF5800" class="px-10" style="height: 55px" @click="submit" :loading="shouldLoading" :disabled="shouldLoading">Submit</v-btn>
          </v-col>
        </v-row>
        <div class="row">
          <div class="col-12">
            <div class="row d-flex justify-content-end">
              <v-btn color="#ffe905" class="px-10" style="height: 40px" @click="create_pdf" :loading="shouldLoading" :disabled="shouldLoading">Create PDF</v-btn>
            </div>

            
            <bx-box :title="stickersCount + ' Sticker orders '" no-padding :loading="shouldLoading">
              <skeleton-table :columns="7" v-if="shouldLoading" />


              <bx-table v-if="!shouldLoading" :data="data" :columns="columns" paginated backendPagination :currentPage="page" :perPage="itemsPerPage" 
              :total="stickersCount" @search="onSearch" highlight-danger="quantity" @update:currentPage="updatePage">
                <template slot-scope="props">

                  <bx-table-column centered>{{ props.row.id }}</bx-table-column>
                  <bx-table-column centered>{{ props.row.order }}</bx-table-column>
                  <bx-table-column field="state" centered> <sticker-status :status="props.row.state"></sticker-status> </bx-table-column>
                  <bx-table-column centered>{{ props.row.warehouse }}</bx-table-column>
                  <bx-table-column centered>{{ props.row.document_number }}</bx-table-column>
                  <bx-table-column centered>{{ props.row.reference }}</bx-table-column>
                  <bx-table-column centered>{{ props.row.quantity }}</bx-table-column>
                  <bx-table-column centered class="align-items-start d-flex justify-center">
                    <v-checkbox class="shrink mr-0 mt-0 pt-0" color="#FF5800" hide-details @change="onSelectRecord(props.row)" :value="props.row.id" v-model="selectedRows"></v-checkbox>
                  </bx-table-column>
                </template>
              </bx-table>
            </bx-box>


            <v-snackbar :color="snackbarColor" v-model="snackbar" timeout="5000" top right>{{ snackbarText }}</v-snackbar>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <bx-box :title="pdfsCount + ' pdfs '" no-padding :loading="shouldLoading">
              <skeleton-table :columns="7" v-if="shouldLoading" />

              <bx-table :data="data_pdfs" :columns="columns2" paginated v-if="!shouldLoading" backendPagination :currentPage="page2" 
              :perPage="itemsPerPage" :total="pdfsCount" @search="onSearch" highlight-danger="quantity" @update:currentPage="updatePage2">
                <template slot-scope="props">
                  <bx-table-column centered>{{ props.row.name }}</bx-table-column>
                  <bx-table-column centered>{{ props.row.stickers }}</bx-table-column>
                  <bx-table-column centered>{{ props.row.warehouse }}</bx-table-column>
                  <bx-table-column centered>{{ props.row.quantity }}</bx-table-column>
                  <bx-table-column><img @click="downloadFile(props.row.id)" style="cursor: pointer" src="@/assets/i/Icon-download.svg"/></bx-table-column>
                </template>
              </bx-table>
            </bx-box>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let states = [
  { value: 0, text: "Pending" },
  { value: 1, text: "Completed" },
];
export default {
  name: "inbound-dashboard",
  data() {
    return {
      shouldLoading: true,
      reloadInterval: null,
      columns: [],
      columns2: [],
      selectedRows: [],
      selectedRecords: [],
      data: [],
      data_pdfs: [],
      key: "inventory_stocks",
      filters: [],
      pending: 0,
      completed: 0,
      total: 0,
      page: 1,
      page2: 1,
      stickersCount: 0,
      pdfsCount: 0,
      itemsPerPage: 10,
      areaList: [],
      locations: [],
      filter_state: null,
      areaSelected: [],
      snackbar: false,
      states: states,
      warehouse: "",
      document_number: "",
      snackbarText: "",
      snackbarColor: "#FF5800",
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    },
  },
  methods: {
    async getLocations() {
      this.locations = await this.$api.brand.locations();
    },
    onSearch(field, value) {
      this.$session.set(this.key + field, value);
      this.filters[field] = value;
      this.getData();
    },
    onSelectRecord(item) {
      let foundIndex = this.selectedRecords.findIndex((x) => x.id === item.id);
      if (foundIndex === -1) {
        this.selectedRecords.push(item);
      } else {
        this.selectedRecords.splice(foundIndex, 1);
      }
      console.log("onSelected: "+this.selectedRecords)
    },
    async downloadFile(id) {
      try {
        await this.$api.stickers.download(id);
      } catch (error) {
        console.log(error);
      }
    },
    updatePage(p) {
      this.shouldLoading = true;
      this.page = p;
      this.data=[]
      this.getData();
      this.get_stickers()
      this.shouldLoading = false;
    },
    updatePage2(p) {
      this.page2 = p;
      this.shouldLoading = true;
      this.get_pdfs()
      this.shouldLoading = false;
    },
    async getData() {
      try {
        await this.getLocations();
        this.columns = [
          {
            field: "id",
            label: this.$t("lang.common.id"),
            centered: true,
          },
          {
            field: "order",
            label: this.$t("lang.common.order"),
            centered: true,
          },
          {
            field: "state",
            label: this.$t("lang.common.state"),
            witdh: 50,
          },
          {
            field: "warehouse",
            label: this.$t("lang.common.warehouse"),
            centered: true,
          },
          {
            field: "document_number",
            label: this.$t("lang.common.document_number"),
            centered: true,
          },
          {
            field: "reference",
            label: this.$t("lang.common.reference"),
            centered: true,
          },
          {
            field: "quantity",
            label: this.$t("lang.common.quantity"),
            centered: true,
            witdh: 15
          },
          {
            field: "select",
            label: this.$t("lang.common.select"),
            centered: true,
          }
        ];
        this.columns2 = [
          {
            field: "name",
            label: this.$t("lang.common.name"),
            witdh: 50,
          },
          {
            field: "stickers",
            label: this.$t("lang.common.stickers"),
            centered: true,
          },
          {
            field: "warehouse",
            label: this.$t("lang.common.warehouse"),
            centered: true,
          },
          {
            field: "item_count",
            label: this.$t("lang.common.quantity"),
          },
          {
            field: "download",
            label: this.$t("lang.common.download"),
            centered: true,
          },
        ];
      } catch (error) {
        console.log(error);
      } finally {
        this.shouldLoading = false;
      }
    },
        async get_pdfs(){
        const pdfs = await this.$api.stickers.pdfs( this.warehouse,
        {
          offset: (this.page2 - 1) * this.itemsPerPage,
          limit: this.itemsPerPage,
        }
      );
      if (pdfs.results.length) {
        this.pdfsCount = pdfs.count;
        this.data_pdfs = pdfs.results.map((item) => {
          return {
            id: item.id,
            name: item.name,
            warehouse: item.warehouse,
            document_number: item.document_number,
            quantity: item.quantity,
            stickers: item.stickers

          };
        });
      } else {
        this.pdfsCount = pdfs.count;
        this.data_pdfs = [];
        this.snackbarText = "No results found";
        this.snackbarColor = "red darken-2";
        this.snackbar = true;
      }
    },
    async get_stickers(){
        const stickers = await this.$api.stickers.stickers(
        {
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage,
          warehouse: this.warehouse,
          document_number: this.document_number,
          status: this.filter_state,
          order_by: "id"
        }
      );
      if (stickers.results.length) {
        this.stickersCount = stickers.count;
        this.data = stickers.results.map((item) => {
          return {
            id: item.id,
            order: item.order,
            state: item.status,
            warehouse: item.warehouse,
            document_number: item.document_number,
            quantity: item.quantity,
            reference: item.reference

          };
        });
      } else {
        this.stickersCount = stickers.count;
        this.data = [];
        this.snackbarText = "No results found";
        this.snackbarColor = "red darken-2";
        this.snackbar = true;
      }
    },
    async submit() {
      this.shouldLoading = true;
      this.data=[]
      this.data2=[]
      this.getData();
      this.get_stickers()
      this.get_pdfs()
      this.selectedRecords = []
      this.selectedRows= []
      this.shouldLoading = false;
    },
    async create_pdf() {
      this.shouldLoading = true;
      var stickers=[]
      this.selectedRecords.forEach(item => {
        stickers.push(item.id)
      });
      await this.$api.stickers.create_pdf(
        {
          stickers: stickers,
        }
      );
      this.shouldLoading = false;
    },
  },
  async mounted() {
    this.getData();
    this.filters.gtin = this.$session.get(this.key + "gtin");
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  },
};
</script>
